import { detect } from 'detect-browser';

const browser = detect();

const PRODUCTION_HOST = 'www.royalhealthcare.asia';
const PRODUCTION_HOST_EXTRA = 'royalhealthcare.asia';
const PRODUCTION_HOST2 = 'www.prod2.royalhealthcare.asia';
const PRODUCTION_HOST_EXTRA2 = 'prod2.royalhealthcare.asia';
const PRODUCTION_HOST3 = 'www.v1.royalhealthcare.asia';
const PRODUCTION_HOST_EXTRA3 = 'v1.royalhealthcare.asia';

const HOST_DEV = 'beta.royalhealthcare.asia';
const LOCAL_HOST = 'localhost:3000';

const IS_PRODUCTION =
  location.host === PRODUCTION_HOST ||
  location.host === PRODUCTION_HOST_EXTRA ||
  location.host === PRODUCTION_HOST2 ||
  location.host === PRODUCTION_HOST_EXTRA2 ||
  location.host === PRODUCTION_HOST3 ||
  location.host === PRODUCTION_HOST_EXTRA3;
const IS_DEV = location.host === HOST_DEV;
const IS_LOCAL = location.origin === `http://${LOCAL_HOST}`;
const IS_SAFARI = browser?.name === 'safari';
const IS_WINDOWS = browser?.os?.match(/Windows/);
const GOOGLE_MEET_LINK = 'https://meet.google.com/bse-hbbw-oxr'; // google meet link

/**
 * ENV provides values related to NODE_ENV; user-agent; etc...
 */
export const ENV = {
  IS_PRODUCTION,
  IS_DEV,
  IS_LOCAL,
  IS_SAFARI,
  IS_WINDOWS,
  GOOGLE_MEET_LINK,
} as const;
